<div class="modal-header">
  <h2 mat-dialog-title>Warning: you cannot undo this action!</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <h3 class="pageHeader">Are you sure you want to delete &quot;{{data.project.name}}&quot;?</h3>
  <p>Deleting this project will delete all historical data associated with the selected reporting period.</p><p><strong>This action is permanent and cannot be undone or recovered.</strong></p>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button" (click)="cancel()">Cancel, keep project</button>
  <button type="button" class="button action-alert" (click)="deleteProject()">Yes, delete project</button>
</mat-dialog-actions>
